// extracted by mini-css-extract-plugin
export default {"item":"InternalTransfer_item_PD6hF"};